<h2 mat-dialog-title>Avaliar entrevista</h2>
<div class="btnscoll">
    <div class="button-container">
        <button mat-stroked-button color="primary" class="col-sm-6"
            (click)="openInterview()">
                Listar entrevistas
        </button> 
        
        <button mat-stroked-button color="primary" class="col-sm-6"
            (click)="openInterviewSession()">
                Chamar para entrevista
        </button>
    </div>
</div>
<br>
<mat-dialog-content>

    <div class="empty-content" *ngIf="interviews?.length === 0">
        <span class="mat-body-2">Sem entrevista para avaliar</span>
    </div>

    <ng-container *ngFor="let interview of interviews">
        <div style="margin-bottom: 10px">        
            <h3 class="mat-title">Começa dia {{ interview.date_start | date:'dd/MM/yyyy' }} às {{ formatTime(interview.time_start) }}</h3>
            <p class="mat-body-2" style="margin-bottom: 0;"> Tipo: {{ interview.type === 'true' ? 'Entrevista Remota' : 'Entrevista Presencial' }}</p>
            <span class="mat-body-2" *ngIf="interview.type === 'false'">{{ interview.address }}</span>
            <p class="mat-body-1">Falar com {{ interview.contact }}</p>

            <p class="mat-body-1">Escolha a pontuação dessa entrevista</p>
            <div class="helper" *ngIf="candidateStatus === 'hired'" style="margin-bottom: 10px;">
                Esse candidato já foi contratado, não é possivel alterar pontuação
            </div>
            <p class="mat-body-1" *ngIf="interview.accept === null" style="color: brown">Esperando resposta do candidato para agendamento da entrevista</p>
            <p class="mat-body-1" *ngIf="interview.accept == 0" style="color:red">Candidato rejeitou a entrevista</p>
            <mat-button-toggle-group [value]="interview.points" (change)="onChangePoints($event, interview)"
                [disabled]="interview.accept != 1 || candidateStatus === 'hired'">
                <mat-button-toggle value="5">5</mat-button-toggle>
                <mat-button-toggle value="6">6</mat-button-toggle>
                <mat-button-toggle value="7">7</mat-button-toggle>
                <mat-button-toggle value="8">8</mat-button-toggle>
                <mat-button-toggle value="9">9</mat-button-toggle>
                <mat-button-toggle value="10">10</mat-button-toggle>        
            </mat-button-toggle-group>
            
            <form [formGroup]="formsMap.get(interview.id)">
                <div class="row" style="display: flex; align-items: center; gap: 16px; margin-top: 10px;">
                  <mat-form-field appearance="outline" style="margin-left:0; flex: 1;">
                    <mat-label>Observação</mat-label>
                    <textarea
                      matInput
                      placeholder="Escreva aqui"
                      formControlName="observacao"
                      rows="5"
                      maxlength="1000"
                      id="observacao-{{i}}"
                    ></textarea>
                    <mat-hint>Informe até 1000 caracteres</mat-hint>
                    <mat-error *ngIf="formsMap.get(interview.id)?.get('observacao')?.errors?.maxlength">
                        Por favor informe no máximo 1000 caracteres
                    </mat-error>
                  </mat-form-field>
              
                  <button
                    color="primary"
                    mat-raised-button
                    (click)="submit(interview)"
                    style="margin-top: -14px;"
                  >
                    Salvar
                  </button>
                </div>
            </form>
        </div>
        <mat-divider></mat-divider>
    </ng-container>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true" color="accent">Fechar</button>
    <!--<button *ngIf="processList.status !== 'finished'" mat-raised-button color=primary>Salvar</button>-->
</mat-dialog-actions>